export const NOTIFICATION = "NOTIFICATION";
export const getNotification = (data) => {
    return {
        type: NOTIFICATION,
        payload:data
    }
}